import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=ded39b20&"
import script from "./Dispatch.vue?vue&type=script&lang=js&"
export * from "./Dispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports